import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typeLogObj, typeLogsDoc, typeLogType, typeUser } from '@monorepo/models';

export type typeLogQuery = {
    congregation?: number | null;
    maxDate?: string | null;
    minDate?: string | null;
    offset?: number;
    type?: typeLogType | null;
};

class LogServices {
    private Base = pointer.log;
    //
    Delete = async (congregation: number, log: typeLogObj) => {
        const data = await api.SendRequest(this.Base, 'DELETE', { congregation, log });
        return data;
    }
    GetAll = async (query: typeLogQuery = {}) => {
        const params = new URLSearchParams({
            congregation: query.congregation === null || query.congregation === undefined ? '' : String(query.congregation),
            maxDate: query.maxDate ?? '',
            minDate: query.minDate ?? '',
            offset: String(query.offset ?? 0),
            type: query.type ?? ''
        });
        const data = await api.SendRequest<{ log: typeLogsDoc; logs: typeLogsDoc[]; }>(`${this.Base}?${params.toString()}`, 'GET');
        return data;
    }
    SaveFrontendException = async (user: typeUser, error: Error, errorInfo: React.ErrorInfo) => {
        const locationHRef = window.location.href;
        const errorCause = error.cause ?? '(sin cause)';
        const errorMessage = error.message ?? '(sin message)';
        // const errorStack = error.stack?.replace(/\n/g, " ") ?? "(sin stack)";
        const errorName = error.name ?? '(sin name)';
        const errorInfoComponentStack = errorInfo.componentStack?.replace(/\n/g, ' ') ?? '(sin componentStack)';
        const text = `Excepción no controlada frontend: '${errorName}: ${errorMessage}'; causa: ${errorCause}; stack del componente: ${errorInfoComponentStack}.`;
        console.log(locationHRef, text);
        const data = await api.SendRequest(this.Base, 'POST', { locationHRef, text, user: user.isAuth ? user : null });
        return data;
    }
}

export const logServices = new LogServices();
